import { Link, useParams } from "react-router-dom";

import {
  Empty,
  ErrorState,
  Loading,
} from "../../components/WorkspacePrimitives";
import { useAgentCompanies } from "../api/e2e";
import AgentRunDetails from "../components/AgentRunDetails";
import CompanyWorkspacePage from "../components/CompanyWorkspacePage";
import { companyRunsPath } from "../lib/runRoutes";

export default function AgentCompanyRunDetailPage() {
  const { companyId = "", runId = "" } = useParams<{
    companyId: string;
    runId: string;
  }>();
  const companies = useAgentCompanies();
  const company = companies.data?.find((item) => item.id === companyId);

  if (companies.isPending && !companies.data) {
    return <Loading label="Loading company run…" />;
  }
  if (companies.error && !companies.data) {
    return (
      <ErrorState error={companies.error} onRetry={() => companies.refetch()} />
    );
  }
  if (!company) return <Empty>This company is not available.</Empty>;

  return (
    <CompanyWorkspacePage
      companies={companies.data ?? []}
      company={company}
      className="page--company-run"
    >
      <Link
        className="back-link company-run-page__back"
        to={companyRunsPath({ company_id: company.id })}
      >
        ← Runs
      </Link>
      <AgentRunDetails runId={runId} companyId={companyId} />
    </CompanyWorkspacePage>
  );
}
